module.exports = __webpack_public_path__ + "static/img/ent-detail-77.751ff5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-77.jpg
// module id = yWqF
// module chunks = 51